import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { pdfStyles } from '../../..';
import { TRADER_TYPE } from '../../../../interfaces/moneyCollection.interface';
import { MoneyCollection } from '../../../../interfaces/moneyCollection.interface';

interface Props {
  doc: MoneyCollection;
}

export const PdfMoneyCollectionTitle = ({ doc }: Props) => {
  const { t } = useTranslation();

  const getTitle = useCallback(() => {
    if (doc.traderType === TRADER_TYPE?.[1]?.id) {
      return 'INCOME_FROM_CUSTOMER';
    }
    return 'PAYMENT_TO_SUPPLIER';
  }, [doc.traderType]);

  return (
    <View style={styles.title}>
      <Text style={pdfStyles.headerTitle}>{t(`PDF.${getTitle()}`)}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  title: {
    textDecoration: 'underline',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
